import gql from '@/core/setup/api';
import { Country } from '@sbvr/lbe-types';

export async function getCountries () {
  const query = `{
    countries {
      name
      cca3
    }
  }`;
  const { countries } = await gql.request(query) as { countries: Country[] };
  return countries;
};
